export const Azul = '#0089FF';

export const Vermelho = '#FF0000';

export const Financeiro = [Azul, Vermelho];

export const CinzaEscuro = '#919191';

export const FinanceiroZerado = [CinzaEscuro, CinzaEscuro];

export const Verde = '#03a81e';

export const Contas = [
  "#FFD700", "#1E90FF", "#00CED1", "#32CD32", "#FFA500", "#7B68EE",
  "#00FF7F", "#FF6347", "#DA70D6", "#20B2AA", "#FF00FF", "#90EE90", "#9932CC",
  "#F08080", "#FFFF00", "#FF6EC7", "#8A2BE2", "#FF4500", "#2E8B57", "#FF1493",
  "#40E0D0", "#6A5ACD", "#00FF00", "#4682B4", "#FFB6C1", "#87CEEB", "#8B008B",
  "#FF69B4", "#CD5C5C", "#FFFFE0", "#00FA9A", "#BC8F8F", "#6B8E23",
  "#FF8C00", "#9932CC", "#D2691E", "#FF00FF", "#00CED1", "#FFD700", "#2E8B57",
  "#7B68EE", "#FF6347", "#40E0D0", "#DA70D6", "#1E90FF", "#FF1493", "#FF4500",
  "#20B2AA",
];

export const FluxoCaixa = [Verde, Azul, Vermelho];

export const Vendas = [ Azul ];

export const Preto = '#000000';

export const Fundo = '#f1f1f1';

export const Primario = '#125cb3';

export const SaldoContas = '#03a81e';